import {BeneficiaryPaymentDataSA} from "../../interface/payments.interface";
import {sdkPostMessage} from "../../../util";
import {PostMessageResponse} from "../../../types/sdk-response.interface";


export const payments_sa = {
  beneficiary(paymentData: BeneficiaryPaymentDataSA): Promise<PostMessageResponse> {
    return new Promise((resolve, reject) => {
      sdkPostMessage(
        "pbsa",
        "payments.beneficiary",

        paymentData,
      )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
